import { call } from 'redux-saga/effects';
import { subscribeToScreenshareSaga } from 'features/screenshare/sagas/subscribeToScreenshareSaga';
import { FeedId } from 'features/streaming/types';
import { RTCClient } from 'utils/webrtc';

/**
 * Resumes receiving a screenshare that became visible again. By default restores both
 * video and audio (mirroring the pause, which stops every stream of the feed). Pass
 * videoOnly: true for views where screenshare audio must stay off (the show-all grid).
 */
export function* resumeScreenshareSaga(feedId: FeedId, options: { videoOnly?: boolean } = {}) {
  const { videoOnly = false } = options;

  const userId = RTCClient.userIdByScreensharingFeedId[feedId];
  const streams = RTCClient.receivingFeed.availableScreenshares[feedId];

  if (!userId || !streams?.length) {
    return;
  }

  yield call(subscribeToScreenshareSaga, userId, feedId, streams, { videoOnly });
}
